export enum CustomDomainStatus {
  NotRequested = 'notRequested',
  AwaitingVerification = 'awaitingVerification',
  CannotFindCNameError = 'cannotFindCNameError',
  FoundWithIncorrectValueError = 'foundWithIncorrectValueError',
  UnexpectedError = 'unexpectedError',
  Verified = 'verified',
  Disconnected = 'disconnected',
  Connected = 'connected'
}
